import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { formatSyncedAgo } from "./freshness.js";
import { cx } from "../lib/cx.js";
function resolveTone(syncedAt, now, maxAgeMs) {
    if (syncedAt == null)
        return "never";
    if (maxAgeMs === undefined)
        return "ok";
    const date = typeof syncedAt === "string" ? new Date(syncedAt) : syncedAt;
    if (Number.isNaN(date.getTime()))
        return "never";
    return now.getTime() - date.getTime() > maxAgeMs ? "stale" : "ok";
}
export function FreshnessBadge({ syncedAt, now = new Date(), maxAgeMs, labelOverride, onSyncClick, className, ...rest }) {
    const label = labelOverride ?? formatSyncedAgo(syncedAt, now);
    const tone = resolveTone(syncedAt, now, maxAgeMs);
    const showSync = (tone === "stale" || tone === "never") && onSyncClick;
    return (_jsxs("span", { className: cx("evolua-freshness", `evolua-freshness--${tone}`, className), "data-tone": tone, title: syncedAt
            ? typeof syncedAt === "string"
                ? syncedAt
                : syncedAt.toISOString()
            : undefined, ...rest, children: [label, showSync ? (_jsx("button", { type: "button", className: "evolua-freshness__sync", onClick: onSyncClick, "aria-label": "Sincronizar agora", children: "Sincronizar agora" })) : null] }));
}
//# sourceMappingURL=FreshnessBadge.js.map